import React, { memo, useState, useEffect } from 'react'
import NavTab from '../lib/react-storefront/nav/NavTab'
import NavTabs from '../lib/react-storefront/nav/NavTabs'
import Link from 'next/link'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  link: (c) => ({
    display: 'block',
    marginTop: theme.spacing(2),
    '&:first-child': {
      marginTop: 0,
    },
    '&:hover': {
      color: c.hoverColor,
      backgroundColor: c.bgcolor,
    },
  }),
}))

function NavBar({ isBottleZoo, themeColor, fontColor = null, tabs = [] }) {
  const [stickyNav, setStickyNav] = useState(false)
  const [navStyle, setNavStyle] = useState({})

  const c = {
    color: `${fontColor}` + ' !important',
    bgcolor: `${themeColor}` + ' !important',
    hoverColor: fontColor ? `${fontColor}` + ' !important' : '#fff !important',
  }

  const classes = useStyles(c)

  useEffect(() => {
    const onScroll = throttle(() => {
      if (getScrollY() > 0) {
        setStickyNav(true)
        if (!isBottleZoo) {
          setNavStyle({ top: '63px' })
        }
      } else {
        setStickyNav(false)
        setNavStyle({})
      }
    }, 0)

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  if (!tabs || !Array.isArray(tabs) || tabs.length === 0) return null

  return (
    <NavTabs className={'navbar-bg ' + (stickyNav ? 'sticky-nav ' : '')} style={navStyle}>
      {tabs.map((tab) => {
        return (
          <NavTab
          key={tab.text}
          href={tab.href}
          as={tab.as || tab.href}
          label={tab.text}
          className="navigation-link"
          classes={{ paper: 'menu-blk-outer ' + (tab.items?.length === 0 ? 'hide-menu ' : '') }}
        >
          {tab.items?.length > 0 && (
            <div className="menu-blk" style={{ padding: 20 }}>
              <div className="menu-outer">
                <div className="main-cate">
                  {tab.items
                    .filter((sc) => sc.href)
                    .map((sc) => (
                      <div key={sc.as || sc.href}>
                        <Link
                          href={sc.href}
                          as={sc.as || sc.href}
                          className={classes.link}
                          style={{ textDecoration: 'none', color: 'black' }}
                        >
                          <Typography variant="body1">{sc.text}</Typography>
                        </Link>
                        {sc.items?.length > 0 && (
                          <ul>
                            {sc.items
                              .filter((subcat) => subcat.href)
                              .map((subcat) => (
                                <li key={subcat.as || subcat.href}>
                                  <Link
                                    href={subcat.href}
                                    as={subcat.as || subcat.href}
                                    className={classes.link}
                                    style={{ textDecoration: 'none', color: 'black' }}
                                  >
                                    <Typography variant="body1">{subcat.text}</Typography>
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          )}
        </NavTab>
        )
      })}
    </NavTabs>
  )
}

export default memo(NavBar)

function getScrollY() {
  return window.scrollY || window.pageYOffset
}

function throttle(callback, limit) {
  let waiting = false
  return function () {
    if (!waiting) {
      callback.apply(this, arguments)
      waiting = true
      setTimeout(() => {
        waiting = false
      }, limit)
    }
  }
}
